/* typewriter.ro — product page: gallery, variants, 3D sync, switch sound */
(function () {
  var dataEl = document.getElementById('twProductData');
  if (!dataEl) return;
  var P = {};
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var STEM = { linear: '#d0202a', tactile: '#6b4128', clicky: '#1d5ed6' };
  function swKind(v) { v = String(v || '').toLowerCase(); return v.indexOf('click') > -1 ? 'clicky' : v.indexOf('tactil') > -1 ? 'tactile' : 'linear'; }

  // ---------- gallery ----------
  var gal = document.getElementById('twGal');
  document.querySelectorAll('.pd-thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.getAttribute('data-t');
      document.querySelectorAll('.pd-thumbs button').forEach(function (x) { x.classList.toggle('on', x === b); });
      gal.querySelectorAll('.gv').forEach(function (v) { v.classList.toggle('on', v.getAttribute('data-v') === t); });
    });
  });

  // ---------- quantity ----------
  var form = document.getElementById('TwProductForm');
  if (form) form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    var i = form.querySelector('input[name="quantity"]');
    i.value = Math.max(1, Math.min(10, (parseInt(i.value, 10) || 1) + Number(b.getAttribute('data-q'))));
  });

  // lei / € lives in tw-site.js (window.twMoney); translations of option values come from the shop dictionary
  var DICT = P.dict || {};
  function tr(v) { return document.documentElement.lang === 'en' && DICT[v] ? DICT[v] : v; }
  function setText(el, v) { if (!el) return; el.setAttribute('data-ro', v); el.setAttribute('data-en', DICT[v] || v); el.innerHTML = tr(v); }

  // ---------- variants ----------
  function selected() {
    var out = [];
    document.querySelectorAll('.pd-opt').forEach(function (f) {
      var c = f.querySelector('input:checked'); out[Number(f.getAttribute('data-opt'))] = c ? c.value : null;
    });
    return out;
  }
  function apply3d(sel) {
    if (!window.__twkb) return;
    if (P.swIndex > -1) window.__twkb.set({ stem: STEM[swKind(sel[P.swIndex])] });
    if (P.colIndex > -1 && P.colorways && P.colorways[sel[P.colIndex]]) window.__twkb.set(P.colorways[sel[P.colIndex]]);
  }
  function update() {
    var sel = selected();
    document.querySelectorAll('.pd-opt').forEach(function (f) {
      var i = Number(f.getAttribute('data-opt')); setText(f.querySelector('.sel'), sel[i]);
    });
    var v = (P.variants || []).filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
    if (v) {
      var id = document.getElementById('twVariant'); if (id) id.value = v.id;
      var pr = document.getElementById('twPrice'); if (pr) { pr.setAttribute('data-cents', v.cents); pr.setAttribute('data-ron', v.price); if (window.twMoney) window.twMoney.render(); }
      var cp = document.getElementById('twCompare'); if (cp) { cp.innerHTML = v.compare || ''; cp.hidden = !v.compare; }
      var add = document.getElementById('twAdd'); if (add && !P.demo) add.disabled = !v.available;
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    if (P.swIndex > -1) setText(document.getElementById('twSwName'), sel[P.swIndex]);
    apply3d(sel);
  }
  document.querySelectorAll('.pd-opt input').forEach(function (i) { i.addEventListener('change', function () { update(); if (P.swIndex > -1 && i.name === 'opt' + P.swIndex) play(); }); });
  // 3D: underglow off by default (quieter look), hint fades after the first drag
  function kbReady() {
    apply3d(selected());
    var k = window.__twkb;
    if (k && k.state) { k.state.lightsT = 0; k.state.lights = 0; }
    var lb = document.querySelector('.kb-ui [data-a="lights"]'); if (lb) lb.classList.remove('on');
    var host = document.getElementById('twKb3d'), hint = document.querySelector('.pd-stage .hint');
    if (host && hint) host.addEventListener('pointerdown', function () { hint.classList.add('off'); }, { once: true });
  }
  if (window.__twkb) kbReady();
  else document.addEventListener('tw:kb-ready', kbReady);

  // ---------- switch sound (synthesised; real products get a recording) ----------
  var ctx = null, playing = false;
  var wave = document.getElementById('twWave'), bars = [];
  if (wave) {
    for (var i = 0; i < 40; i++) { var e = document.createElement('i'); e.style.height = '4px'; wave.appendChild(e); bars.push(e); }
  }
  function noiseBuf(len) {
    var b = ctx.createBuffer(1, Math.floor(ctx.sampleRate * len), ctx.sampleRate), d = b.getChannelData(0);
    for (var i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 3);
    return b;
  }
  function burst(t, len, type, freq, q, gain) {
    var s = ctx.createBufferSource(); s.buffer = noiseBuf(len);
    var f = ctx.createBiquadFilter(); f.type = type; f.frequency.value = freq; f.Q.value = q;
    var g = ctx.createGain(); g.gain.value = gain;
    s.connect(f); f.connect(g); g.connect(ctx.destination); s.start(t);
  }
  function thud(t, freq, len, gain) {
    var o = ctx.createOscillator(); o.type = 'sine'; o.frequency.setValueAtTime(freq, t); o.frequency.exponentialRampToValueAtTime(freq * 0.55, t + len);
    var g = ctx.createGain(); g.gain.setValueAtTime(gain, t); g.gain.exponentialRampToValueAtTime(0.0001, t + len);
    o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t + len + 0.02);
  }
  function stroke(t, kind, heavy) {
    var k = heavy ? 1.35 : 1;
    if (kind === 'clicky') { burst(t, 0.012, 'highpass', 3600, 0.7, 0.9); burst(t + 0.004, 0.02, 'bandpass', 5200, 2, 0.5); }
    if (kind === 'tactile') burst(t, 0.03, 'bandpass', 1900, 1.2, 0.35);
    // bottom-out: body of the case + plastic
    burst(t + 0.018, 0.07 * k, 'bandpass', heavy ? 700 : 1100, 0.9, 0.85);
    thud(t + 0.018, heavy ? 130 : 170, 0.07 * k, 0.5);
    // upstroke
    var up = t + 0.09 + Math.random() * 0.05;
    burst(up, 0.05, 'bandpass', kind === 'linear' ? 1500 : 1800, 1, 0.3);
    if (kind === 'clicky') burst(up, 0.01, 'highpass', 3800, 0.7, 0.4);
  }
  function play() {
    var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume();
    if (playing) return;
    playing = true;
    var sel = selected(), kind = swKind(P.swIndex > -1 ? sel[P.swIndex] : P.sound);
    var t = ctx.currentTime + 0.05, times = [];
    for (var i = 0; i < 16; i++) {
      var heavy = i === 7 || i === 15;
      stroke(t, kind, heavy); times.push(t);
      t += 0.11 + Math.random() * 0.12 + (heavy ? 0.12 : 0);
    }
    var end = t, btn = document.getElementById('twPlay');
    if (btn) btn.classList.add('on');
    (function anim() {
      var now = ctx.currentTime;
      bars.forEach(function (b, j) {
        var x = now - (39 - j) * 0.02, a = 0;
        times.forEach(function (tt) { var d = x - tt; if (d > 0 && d < 0.18) a = Math.max(a, 1 - d / 0.18); });
        b.style.height = (4 + a * 26 * (0.7 + 0.3 * Math.sin(j * 1.7))) + 'px';
      });
      if (now < end + 0.4) requestAnimationFrame(anim);
      else { playing = false; if (btn) btn.classList.remove('on'); bars.forEach(function (b) { b.style.height = '4px'; }); }
    })();
    if (window.__twkb && window.__twkb.state) { /* small visual cue: nothing heavy */ }
  }
  var pb = document.getElementById('twPlay'); if (pb) pb.addEventListener('click', play);
})();
